import { PropertyService } from "@propertelligent/client-api";
import {
  FAIL_GET_PROPERTY,
  REQUEST_GET_PROPERTY,
  SUCCESS_GET_PROPERTY,
} from "./types";

export const getProperty = (propertyId) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_GET_PROPERTY });

    const res = await PropertyService.getApiProperty1(propertyId);

    if (res.success) {
      dispatch({ type: SUCCESS_GET_PROPERTY, payload: res.success });
    } else {
      throw new Error("Property request was not successful.");
    }
  } catch (error) {
    dispatch({
      type: FAIL_GET_PROPERTY,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
